import * as React from 'react';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import ArticleIcon from '@mui/icons-material/Article';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { useQuery } from '../hooks/useQuery';
import { useAuth } from '../hooks/useAuth';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import IconButton from '@mui/material/IconButton';
import AlertaProtocoloVencido from '../components/AlertaProtocoloVencido';
import { PagamentoFormPage } from './PagamentoForm';
import { PagamentoAnexoPage } from './PagamentoAnexo';

const steps = ['Preencher formulário', 'Carregar Anexos'];

export const PagamentoDiretoPage = () => {
  const { user, isUsuarioSebrae } = useAuth();
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());
  const [isLoading, setIsLoading] = React.useState(false);
  const [pagamentoDiretoId, setPagamentoDiretoId] = React.useState(null);
  const [numeroDocumentoFiscal, setNumeroDocumentoFiscal] = React.useState('');
  const navigate = useNavigate();

  React.useEffect(() => {}, []);

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const handleStep = (step) => () => {
    setActiveStep(step);
  };

  const renderStepAtual = () => {
    switch (activeStep) {
      case 0:
        return (
          <PagamentoFormPage
            steps={steps}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            setPagamentoDiretoId={setPagamentoDiretoId}
            setNumeroDocumentoFiscal={setNumeroDocumentoFiscal}
          />
        );
      case 1:
        return (
          <PagamentoAnexoPage
            steps={steps}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            pagamentoDiretoId={pagamentoDiretoId}
          />
        );
      default:
        break;
    }
  };

  return (
    <Box mt={8} sx={{ width: '100%', background: '#FAFCFF' }}>
      <AppBar position="static" color={'primary'} style={{ padding: 10 }}>
        <Grid container spacing={0}>
          <Grid
            item
            xs={12.5}
            alignItems={'center'}
            display={'flex'}
            justifyContent="space-between"
          >
            <Grid item display="flex" alignItems="center">
              <IconButton
                onClick={() => {
                  if (activeStep === 0) {
                    navigate(`/dashboard/pagamento-direto/`);
                  } else {
                    setActiveStep(activeStep - 1);
                  }
                }}
              >
                <ArrowBackIcon
                  sx={{
                    fontSize: 30,
                    display: { xs: 'none', md: 'flex' },
                    color: '#fff',
                  }}
                />
              </IconButton>

              <ArticleIcon
                sx={{
                  fontSize: 40,
                  display: { xs: 'none', md: 'flex' },
                  mr: 1,
                }}
              />
              <span style={{ color: 'white', fontSize: 20 }}>
                Pagamento Direto
              </span>
            </Grid>

            <Grid item display="flex" alignItems="center">
              {numeroDocumentoFiscal &&
                `Número do Documento Fiscal: ${numeroDocumentoFiscal}`}
            </Grid>
          </Grid>
        </Grid>
      </AppBar>
      <AlertaProtocoloVencido />

      {isLoading ? (
        <p>Carregando...</p>
      ) : (
        <Box padding={5}>
          <Grid container spacing={10}>
            <Grid item sm={12} display={'flex'} justifyContent={'flex-end'}>
              <Box sx={{ width: '100%' }}>
                <Stepper activeStep={activeStep} style={{ width: '50%' }}>
                  {steps.map((label, index) => {
                    const stepProps = {};
                    const labelProps = {};
                    if (isStepSkipped(index)) {
                      stepProps.completed = false;
                    }
                    return (
                      <Step key={label} {...stepProps}>
                        <StepButton color="inherit" onClick={handleStep(index)}>
                          {label}
                        </StepButton>
                        {/* <StepLabel {...labelProps}>{label}</StepLabel> */}
                      </Step>
                    );
                  })}
                </Stepper>
                {renderStepAtual()}
              </Box>
            </Grid>
          </Grid>
        </Box>
      )}
    </Box>
  );
};
